import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {AutocompleteModule} from '../../../components/autocomplete';
import {SelectInputObjectModule} from '../../../components/select-input-object';
import {L10nModule} from '../../../components/translate';
import {DisplayExchangeAccountFactory} from '../../../factories/display-exchange-account.factory';
import {AccountAutocompleteComponent, AccountIdAutocompleteComponent} from './account-autocomplete';
import {AccountBaseAutocompleteComponent} from './account-autocomplete/account-base-autocomplete.component';
import {SelectAccountComponent} from './select-account.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        L10nModule,
        SelectInputObjectModule,
        AutocompleteModule
    ],
    declarations: [
        SelectAccountComponent,
        AccountAutocompleteComponent,
        AccountIdAutocompleteComponent,
        AccountBaseAutocompleteComponent
    ],
    exports: [
        SelectAccountComponent,
        AccountAutocompleteComponent,
        AccountIdAutocompleteComponent,
        AccountBaseAutocompleteComponent
    ],
    providers: [
        DisplayExchangeAccountFactory
    ]
})
export class SelectAccountModule {}
